// import Img1 from "./../../../public/assets/images/vedio_youtube/1.jpeg";
// import Img2 from "./../../../public/assets/images/vedio_youtube/2.jpeg";

import VideoCard from "./components/VideoCard";
import Data from "../../data/vedio_youtube.json";

function VideoYoutube() {
  return (
    <section className="mentor video-youtube my-5" id="videoYoutube">
      <div className="container my-5">
      <h2 className="text-center font-weight-bold" style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>Real Stories, Real Success</b></h2>
        <h3 className="text-center" style={{fontSize: 16}}>
          Reviews of the candidates enrolled in Logicmojo Data Science Course.
        </h3>
       
        <div className="review_scroll_sec">
         
          {Data.map((data) => (
            <div className="review_scroll_inner" key={data.id}>
              {data.items.map((item) => (
                <VideoCard key={item.id} {...item} />
              ))}
            </div>
          ))}
          {/* </div> */}
        </div>
      </div>
    </section>
  );
}
export default VideoYoutube;
